export const PRICING_HEADING_CONSTANTS = {
  title: "Shared Resources Pricing",
  organization_server: "Dedicated Server for Organization (for 10+ Users)",
  user_server: "Dedicated VM Minimum 10 user(1:1 VM )",
};
